import React from 'react';
import { Sidebar } from './Sidebar';
import { UserMenu } from './UserMenu';
import { useUI } from '../../contexts/UIStateContext';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  // #72: the bar is a sibling of <main>, not a child, so it already sits
  // outside the only scrolling container on the page. Putting the page name
  // here means it survives scrolling for free — no sticky positioning, no
  // z-index stack to keep in order, and nothing a grid header can overlap.
  const { pageTitle } = useUI();

  return (
    <div className="flex h-screen bg-background" dir="rtl">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Blue top bar: page title on the right (RTL start), UserMenu left */}
        <div className="h-16 bg-primary flex items-center px-6 justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            {pageTitle && (
              // min-w-0 + truncate: a long customer name must shorten rather
              // than push the UserMenu off the end of the bar.
              <div className="min-w-0" data-testid="page-title">
                <h1 className="truncate text-xl font-bold leading-tight text-primary-foreground">
                  {pageTitle.title}
                </h1>
                {pageTitle.subtitle && (
                  <p className="truncate text-xs leading-tight text-primary-foreground/80">
                    {pageTitle.subtitle}
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="flex items-center flex-shrink-0">
            <UserMenu />
          </div>
        </div>
        <main className="flex-1 overflow-auto p-6">{children}</main>
      </div>
    </div>
  );
}
